<template>
  <div>
    <a href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/rerunIntensityDMComponent.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <br/>
    <h4 style="color:green;"> For better performance, run the online waterfaller before re-running dm pipeline to get the best parameters </h4>
    <b-form @submit="rerunIntensityDMPipeline">
      <h5>Basic Parameters:</h5>
      <p>
        DM: The central DM (a float in pc/cc) used for dedispersion during the boxcar convolution DM optimization method. Trial dedispersion values are in the range (input_dm +/- dm_range) if dm_range is given, else they are in the range (input_dm +/- 2 * bonsai_dm_error).
      </p>
      <b-form-group label-cols="4" label="DM:" label-for="dm_input">
        <b-form-input label-cols="4" label="DM:" id="dm_input" v-model="intensityDMPipelineForm.input_dm"/>
      </b-form-group>
      <p>
        Downsampling Factor: The unitless factor (int) with which to downsample the data in time before using the boxcar convolution DM optimization method. Useful to obtain a better DM for wide pulses. In the case that a pulse is extremely wide, it may be necessary to downsample the data by as much as a factor of 8 to refine the DM optimization, but usually a factor of 2 or 4 should suffice.
      </p>
      <b-form-group label-cols="4" label="Downsampling factor:" label-for="downsample_input">
        <b-form-input id="downsample_input" v-model="intensityDMPipelineForm.downsample_factor"/>
      </b-form-group>
      <p>
        DM Range: The DM range (a float in pc/cc) around input_dm used for dedispersion during the boxcar convolution DM optimization method (see definition above). If no input_dm is given, the bonsai DM will be taken as the central trial value instead. Note that the boxcar convolution method does dedispersion trials in minimum steps of 0.025 pc/cc, so it is not recommended to set a DM range much lower than around 1.25 pc/cc (corresponding to ~100 different trial DMs).
      </p>
      <b-form-group label-cols="4" label="DM Range:" label-for="dm_range_input">
        <b-form-input label-cols="4" label="DM Range:" id="dm_range_input" v-model="intensityDMPipelineForm.dm_range"/>
      </b-form-group>
      <p>
        Center Frequency (MHz): The center frequency guess (list of floats) is used as input for estimate_bandwidth as initial guesses for the curve fit of running power law. For multi-beam, enter in numerical order of detection beams from low to high, e.g. [600.0, 550.0] for beam #s 0032 and 1032, respectively. To see multi-beam results, refer to the all-beams waterfall plot under "Show Diagnostic Plots". For single-beam enter as list of len 1, e.g. [600.0]. It is also necessary to enter a bandwidth guess (field below).
      </p>
      <b-form-group label-cols="4" label="Center Frequency:" label-for="fcenter_input">
        <b-form-input label-cols="4" label="Center Frequency:" id="fcenters_input" v-model="intensityDMPipelineForm.fcenter"/>
      </b-form-group>
      <p>
        Bandwidth (MHz): The bandwidth guess (list of floats) is used as input for estimate_bandwidth as initial guesses for the curve fit of running power law. For multi-beam, enter in numerical order of detection beams from low to high, e.g. [400.19, 260.0] for beam #s 0032 and 1032, respectively. To see multi-beam results, refer to the all-beams waterfall plot under "Show Diagnostic Plots". For single-beam enter as list of len 1, e.g. [380.0]. It is also necessary to enter a center frequency guess (field above).
      </p>
      <b-form-group label-cols="4" label="Bandwidth:" label-for="bandwidth_guess_input">
        <b-form-input label-cols="4" label="Bandwidth:" id="bandwidth_guess_input" v-model="intensityDMPipelineForm.bandwidth_guess"/>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
export default{
  props: [
    'rerunIntensityDMPipeline',
    'intensityDMPipelineForm'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/rerunIntensityDMComponent.vue